import React, { useCallback, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import styled from "styled-components/macro";
import axios from "axios";
import { newcriticalSensorType } from "../../../reducer/postpayloadtypes";

interface Props {
	selectedTag: any;
	selectedOption: any;
	enviromentTag: any;
	setReload: any;
}

interface tagRageType {
	alarmLowerLimit: number;
	alarmUpperLimit: number;
	tagRangeId: number;
}


interface criticalSensorType {
	tagId: number;
	name: string;
	tagRange: tagRageType;
}

const CriticalBox = ({ selectedTag, selectedOption, enviromentTag, setReload }: Props) => {

	const [sensor, setSensor] = useState<criticalSensorType | null>(null);
	const [newSensorSetting, setNewSensorSetting] = useState<tagRageType>({
		alarmLowerLimit: 0,
		alarmUpperLimit: 0,
		tagRangeId: 0
	});

	//! 💛 API
	// 임계치 저장 API
	const postfunc = useCallback(async () => {
		try {
			const response = await axios.put(`ifactory/api/tagrange`, { ...newSensorSetting });
			if (response.status === 200) {
				confirmAlert({
					title: "임계치 설정에 성공하였습니다.",
					buttons: [{ label: "Yes" }],
				});
			} else {
				alert(response.data.message);
			}
		} catch (error: any) {
			alert(error.response.data.message);
		}
	}, [newSensorSetting]);


	//! 💛 useEffect
	// selectedTag가 바뀔때마다 해당 정보로 eviromentTag에서 sensor를 찾아서 사용
	useEffect(() => {
		const sensor = enviromentTag.find((item: criticalSensorType) => Number(item.tagId) === Number(selectedTag.tagId));
		setSensor(sensor);
	}, [selectedTag]);

	useEffect(() => {
		if (sensor) {
			setNewSensorSetting(sensor.tagRange);
		}
	}, [sensor]);

	//! 💛 Event
	// 임계치 설정
	const InputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (sensor) {
			setNewSensorSetting({ ...newSensorSetting, [e.target.name]: Number(e.target.value) });
		}
	};
	// 임계치 저장(excepetion 처리 => 저장 API 호출 => 임계치 재로딩)
	const saveSetting = () => {
		if (!newSensorSetting) {
			alert('센서 정보가 없습니다.');
			return;
		}
		console.log('selectedOption : ', selectedOption);

		postfunc().then(() => {
			setReload((prev: boolean) => !prev);
		});
	};

	return (
		// sensor가 있을때만 렌더링
		sensor &&
		<>
			<SensorBox>
				<h3>{sensor.name} 설정</h3>
				<div>
					<div>
						<p>{sensor.name} 최소</p>
						<input type="number"
							value={newSensorSetting.alarmLowerLimit}
							name="alarmLowerLimit"
							onChange={InputHandler}
						/>
					</div>

					<div>
						<p>{sensor.name} 최대</p>
						<input type="number"
							value={newSensorSetting.alarmUpperLimit}
							name="alarmUpperLimit"
							onChange={InputHandler}
						/>
					</div>
				</div>
				<button onClick={saveSetting}>저장</button>
			</SensorBox>
		</>
	);
};

export default CriticalBox;


// 💛 style 
const SensorBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 20px;
	border: 1px solid #e5e5e5;
	border-radius: 10px;
	box-shadow: 0px 0px 10px 0px #e5e5e5;
	background-color: #f5f5f5;
	text-align: center;

	min-width: 100px;
	width: 40%;
	max-width: 300px;

	h3 {
		margin-bottom: 20px;
	}

	div {
		display: flex;
    flex-direction: column;
		width: 100%;
		margin-bottom: 10px;

		p {
			margin-bottom: 8px;
		}

		input {
			width: 100%;
			height: 30px;
			padding: 5px;
			border: 1px solid #e5e5e5;
			border-radius: 10px;
		}
	}

	button{
		width: 100px;
		height: 30px;
		border-radius: 10px;
		border: none;
		background-color: #73972c;
		color: white;
		cursor: pointer;
	}


`;
